import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
    selectOptionsLink: {
        cursor: 'pointer',
        fontSize: theme.fontSizes.bodySize,
    },
}));
